import React, { useState } from 'react';
import { EmbeddedNotification } from '@signaturit/react-components-library';
import { IEmbeddedNotification } from '@signaturit/react-components-library/dist/lib/components/EmbeddedNotification';

export const EmbeddedNotificationWrapper = (embeddedProps: IEmbeddedNotification) => {
    const [expanded, setExpanded] = useState<boolean>(true);

    const onChange = () => {
        setExpanded(!expanded);
    };

    return (
        <EmbeddedNotification {...embeddedProps} title={embeddedProps.title} onChange={onChange} expanded={expanded} />
    );
};
